import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';

import { Box, Grid, Paper, Typography } from '@mui/material';

const Error404 = ({ t: trans }: WithTranslation) => {
  return (
    <Grid>
      <Paper>
        <Box p={5} textAlign="center">
          <Typography variant="h1">{trans('pages.404.title')}</Typography>
        </Box>
      </Paper>
    </Grid>
  );
};

export default withTranslation()(Error404);
